<template>
  <div class="popup" :id="blockId" ref="popup_wrapper">
    <div class="popup-dialog">
      <button class="popup-close" @click="closePopup()">
        <img src="@img/popup-close.svg" alt="">
      </button>
      <div class="popup-contents">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      missClick: null,
      blockId: 'popup'
    }
  },
  created () {
    this.blockId = 'popup_' + (100 + Math.floor(500 * Math.random()))
  },
  methods: {
    closePopup () {
      this.$emit('closePopup')
    }
  },
  mounted () {
    this.missClick = (item) => {
      let q = document.querySelector('#' + this.blockId)
      if (item.target === q) {
        this.closePopup()
      }
    }
    document.addEventListener('click', this.missClick)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.missClick)
  }
}
</script>

<style lang="scss">
.popup {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 9;
  &-dialog {
    position: relative;
    // height: 650px;
    padding-right: 50px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0px 5px 35px rgba(0, 0, 0, 0.3);
    transition: .3s;
  }
  &-close {
    position: absolute;
    top: 5px;
    right: -45px;
  }
  h4.title {
    font-size: 18px;
  }
  p.subtitle {
    font-size: 14px;
    margin-bottom: 25px;
  }
  &-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    a {
      color: #0033c5;
      font-size: 14px;
    }
  }
  &-contents {
    // overflow: hidden;
    max-width: 90vw;
    // height: 90vh;
  }
  &-content {
    height: 100%;
  }
  &-footer {
    position: relative;
    display: flex;
    justify-content: space-between;
    padding-right: 15px;
    margin-top: 30px;
    font-size: 14px;
    z-index: 2;
    .btn-back {
      color: #0033c5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PopupVue.vue